export const PROMOTION_TYPE = {
  "FIX_PRICE": "固定价格",
  "AMOUNT_OFF": "满减活动"
}

export const ORDER_STATUS = {
  "CANCEL": '取消',
  "NEED_CONFIRM": '待提交',
  "NEED_AUDITING": '待审核',
  "NEED_FINISHED": '待确认结单',
  "FINISHED": '结单',
}



// WEBPACK FOOTER //
// ./src/views/share/confirm-order/constants.js